import React, { useEffect } from 'react';
import $ from 'jquery';

function Slider() {
  useEffect(() => {
    $('.counter').each(function () {
      var $this = $(this),
        countTo = $this.attr('data-count');
      $({ countNum: $this.text() }).animate(
        { countNum: countTo },
        {
          duration: 2000,
          easing: 'linear',
          step: function () { $this.text(Math.floor(this.countNum)); },
          complete: function () { $this.text(this.countNum); },
        }
      );
    });
  }, []);

  const slides = [
    {
      img: 'assets/img/slideg01.jpg',
      h1: 'Take the first step to learn',
      h2: 'Teachers open the door, but you must enter by yourself.',
      p: 'Anyone who has never made a mistake has never tried anything new.',
    },
    {
      img: 'assets/img/slideg04.jpg',
      h1: 'An investment in knowledge',
      h2: 'pays the best interest',
      p: "Apply yourself. Get all the education you can, but then, by God, do something. Don't just stand there, make it happen.",
    },
    {
      img: 'assets/img/slideg02.jpg',
      h1: 'Excellence in Education',
      h2: 'Shaping the leaders of tomorrow',
      p: 'Education is the most powerful weapon which you can use to change the world.',
    },
  ];

  return (
    <>
      <div className="slider">
        {/* Bootstrap Carousel */}
        <div id="mainSlider" className="carousel slide" data-ride="carousel" data-interval="4000">

          {/* Indicators */}
          <ol className="carousel-indicators">
            {slides.map((_, i) => (
              <li key={i} data-target="#mainSlider" data-slide-to={i} className={i === 0 ? 'active' : ''}></li>
            ))}
          </ol>

          {/* Slides */}
          <div className="carousel-inner">
            {slides.map((slide, i) => (
              <div key={i} className={`carousel-item ${i === 0 ? 'active' : ''}`}>
                <div
                  className="single-slide"
                  style={{
                    backgroundImage: `url(${slide.img})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '600px',
                  }}
                >
                  <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.45)' }}></div>
                  <div className="slider-text container" style={{ position: 'relative', zIndex: 2 }}>
                    <div className="slider-caption">
                      <h1>{slide.h1}</h1>
                      <h2>{slide.h2}</h2>
                      <p>{slide.p}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Prev Button */}
          <a className="carousel-control-prev" href="#mainSlider" role="button" data-slide="prev"
            style={{
              width: '50px', height: '50px', background: '#009999',
              borderRadius: '50%', top: '50%', transform: 'translateY(-50%)',
              left: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 1,
            }}>
            <span className="carousel-control-prev-icon" style={{ width: '20px', height: '20px' }}></span>
          </a>

          {/* Next Button */}
          <a className="carousel-control-next" href="#mainSlider" role="button" data-slide="next"
            style={{
              width: '50px', height: '50px', background: '#009999',
              borderRadius: '50%', top: '50%', transform: 'translateY(-50%)',
              right: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 1,
            }}>
            <span className="carousel-control-next-icon" style={{ width: '20px', height: '20px' }}></span>
          </a>
        </div>

        {/* Counter Section */}
        <div className="about_text">
          <div className="container">
            <div id="counter">
              <div className="row text-center">
                {[
                  { count: '300', label: 'Students' },
                  { count: '12', label: 'More than Staff' },
                  { count: '200', label: 'Lectures' },
                  { count: '500', label: 'Notes' },
                ].map((item) => (
                  <div key={item.label} className="col-md-3 col-sm-6 col-6">
                    <div className="thumb">
                      <div className="counter" data-count={item.count}>0</div>
                      <h4 style={{ color: '#009999' }}>{item.label}</h4>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Slider;
